webpackJsonp([1],{

/***/ "+FtO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},[_c('el-carousel',{attrs:{"height":"150px","interval":4000}},[_c('el-carousel-item',[_c('img',{staticStyle:{"object-fit":"contain"},attrs:{"src":__webpack_require__("1AA7")}})]),_vm._v(" "),_c('el-carousel-item',[_c('img',{staticStyle:{"object-fit":"contain"},attrs:{"src":__webpack_require__("921z")}})]),_vm._v(" "),_c('el-carousel-item',[_c('img',{staticStyle:{"object-fit":"contain"},attrs:{"src":__webpack_require__("lL03")}})]),_vm._v(" "),_c('el-carousel-item',[_c('img',{staticStyle:{"object-fit":"contain"},attrs:{"src":__webpack_require__("oKsf")}})]),_vm._v(" "),_c('el-carousel-item',[_c('img',{staticStyle:{"object-fit":"contain"},attrs:{"src":__webpack_require__("r2t2")}})]),_vm._v(" "),_c('el-carousel-item',[_c('img',{staticStyle:{"object-fit":"contain"},attrs:{"src":__webpack_require__("iXIU")}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/yRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__ = __webpack_require__("diQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0d473226_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__("FIJ3");
function injectStyle (ssrContext) {
  __webpack_require__("3GDT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0d473226_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "0YQ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      data: [{
        title: 'Recent peer-reviewed publications out of more than 100 publications',
        data: ['Imanbekova, M., S. Suarasan, Y. Lu, S. Jurchuk and S. Wachsmann-Hogiu (2022). "Recent advances in optical label-free characterization of extracellular vesicles " Nanophotonics 11(12): 2827-2863.', 'Abbasi, R., J. Liu, S. Suarasan and S. Wachsmann-Hogiu (2022). "SE-ECL on CMOS: a miniaturized electrochemiluminescence biosensor." Lab on a Chip 22(5): 994-1005.', 'Liu, J.;  Siavash Moakhar, R.;  Mahshid, S.;  Vasefi, F.; Wachsmann-Hogiu, S., Multimodal electrochemical and SERS platform for chlorfenapyr detection. Applied Surface Science 2021, 566, 150617.', 'Imanbekova, M.;  Suarasan, S.;  Rojalin, T.;  Mizenko, R. R.;  Hilt, S.;  Mathur, M.;  Lepine, P.;  Nicouleau, M.;  Mohamed, N.-V.;  Durcan, T. M.;  Carney, R. P.;  Voss, J. C.; Wachsmann-Hogiu, S., Identification of amyloid beta in small extracellular vesicles via Raman spectroscopy. Nanoscale Advances 2021, 3 (14), 4119-4132.', 'Jalali, M.;  Isaac Hosseini, I.;  AbdelFatah, T.;  Montermini, L.;  Wachsmann Hogiu, S.;  Rak, J.; Mahshid, S., Plasmonic nanobowtiefluidic device for sensitive detection of glioma extracellular vesicles by Raman spectrometry. Lab on a Chip 2021, 21 (5), 855-866.', 'Rojalin, T., H. J. Koster, J. Liu, R. R. Mizenko, D. Tran, S. Wachsmann-Hogiu and R. P. Carney (2020). "Hybrid Nanoplasmonic Porous Biomaterial Scaffold for Liquid Biopsy Diagnostics Using Extracellular Vesicles." ACS Sensors 5(9): 2820-2833.', 'Imanbekova, M., A. S. Perumal, S. Kheireddine, D. V. Nicolau and S. Wachsmann-Hogiu (2020). "Lensless, reflection-based dark-field microscopy (RDFM) on a CMOS chip." Biomedical Optics Express 11(9): 4942-4959.', 'Liu, J., R. Siavash Moakhar, A. Sudalaiyadum Perumal, H. N. Roman, S. Mahshid and S. Wachsmann-Hogiu (2020). "An AgNP-deposited commercial electrochemistry test strip as a platform for urea detection." Scientific Reports 10(1): 9527.', 'Suarasan, S., J. Liu, M. Imanbekova, T. Rojalin, S. Hilt, J. C. Voss and S. Wachsmann-Hogiu (2020). "Superhydrophobic bowl-like SERS substrates patterned from CMOS sensors for extracellular vesicle characterization." Journal of Materials Chemistry B.', 'Liu, J., M. Jalali, S. Mahshid and S. Wachsmann-Hogiu (2020). "Are plasmonic optical biosensors ready for use in point-of-need applications?" Analyst 145(2): 364-384.', 'Kheireddine, S., Z. J. Smith, D. V. Nicolau and S. Wachsmann-Hogiu (2019). "Simple adaptive mobile phone screen illumination for dual phone differential phase contrast (DPDPC) microscopy." Biomedical Optics Express 10(9): 4369-4380.', 'Wachsmann-Hogiu, S., Z. J. Smith and M. Kahraman (2019). "Editorial: Plasmonic Technologies for Bioanalytical Applications." Frontiers in chemistry 7: 865-865.', 'Kheireddine, S., A. Sudalaiyadum Perumal, Z. J. Smith, D. V. Nicolau and S. Wachsmann-Hogiu (2019). "Dual-phone illumination-imaging system for high resolution and large field of view multi-modal microscopy." Lab on a Chip 19(5): 825-836.', 'Falco C. M. J. M. van Delft, Giulia Ipolitti, Dan V. Nicolau, Jr, Ayyappasamy Sudalaiyadum Perumal, Ondřej Kašpar, Sara Kheireddine, Sebastian Wachsmann-Hogiu, Dan V. Nicolau: Something Has to Give: Scaling Combinatorial Computing by Biological Agents Exploring Physical Networks Encoding Np-Complete Problems. J Interface focus, 10/2018, DOI: 10.1098/rsfs.2018.0034', 'Magdalena M. Kordon, Aleksander Szczurek, Krzysztof Berniak, Oskar Szelest, Kamil Solarczyk, Magdalena Tworzydło, Sebastian Wachsmann-Hogiu, Anne Vaahtokari, Christoph Cremer, Thoru Pederson, Jurek W. Dobrucki: PML-like subnuclear bodies, containing XRCC1, juxtaposed to DNA replication-based single-strand breaks. The FASEB Journal, 09/2018, DOI: 10.1096/fj.201801379R', 'Stijn Van Cleuvenbergen, Zachary J. Smith, Olivier Deschaume, Carmen Bartic, Sebastian Wachsmann-Hogiu, Thierry Verbiest,Monique A. van der Veen: Morphology and structure of ZIF-8 during crystallisation measured by dynamic angle-resolved second harmonic scattering. Nature Communications, 08/2018, 9(1), 3418. doi:10.1038/s41467-018-05713-4', 'Aysun Korkmaz, Maya Kenton, Gulsen Aksin, Mehmet Kahraman,Sebastian Wachsmann-Hogiu: Inexpensive and Flexible SERS Substrates on Adhesive Tape Based on Biosilica Plasmonic Nanocomposites. ACS Applied Nano Materials, 08/2018, 1(9), 5316-5326. doi:10.1021/acsanm.8b01336', 'Silvia Hilt, Robin Altman, Tamás Kálai, Izumi Maezawa, Qizhi Gong, Sebastian Wachsmann-Hogiu, Lee-Way Jin, and John C. Voss, “A Bifunctional Anti-Amyloid Blocks Oxidative Stress and the Accumulation of Intraneuronal Amyloid-Beta”, Molecules, 08/2018, doi:10.3390/molecules23082010', 'Lieshu Tong, Josef Kauer, Sebastian Wachsmann-Hogiu, Kaiqin Chu, Hu Dou, Zachary J. Smith: A new red cell index and portable RBC analyzer for screening of iron deficiency and Thalassemia minor in a Chinese population. Scientific Reports 12/2017; 7(1)., DOI:10.1038/s41598-017-11144-w', 'Silvia Hilt, Tatu Petteri Rojalin, Tapani Viitala, Artturi Koivuniemi, Alex Bunker, Sebastian Wachsmann-Hogiu, Tamas Kalai, Kalman Hideg, Marjo Yliperttula, John C. Voss: Oligomerization Alters Binding Affinity Between Amyloid Beta and a Modulator of Peptide Aggregation. The Journal of Physical Chemistry C 10/2017;, DOI:10.1021/acs.jpcc.7b06164', 'Miquel Avella-Oliver, Rosa Puchades, Sebastian Wachsmann-Hogiu, Angel Maquieira: Label-free SERS analysis of proteins and exosomes with large-scale substrates from recordable compact disks. Sensors and Actuators B Chemical 06/2017; 252., DOI:10.1016/j.snb.2017.06.058', 'Olga Baum, Sebastian Wachsmann-Hogiu, Thomas Milner, Emil Sobol: Laser-assisted formation of micropores and nanobubbles in sclera promote stable normalization of intraocular pressure. Laser Physics Letters 06/2017; 14(6):065601., DOI:10.1088/1612-202X/aa6b1a', 'Emil Sobol, Olga Baum, Anatoly Shekhter, Sebastian Wachsmann-Hogiu, Alexander Shnirelman, Yulia Alexandrovskaya, Ivan Sadovskyy, Valerii Vinokur: Laser-induced micropore formation and modification of cartilage structure in osteoarthritis healing. Journal of Biomedical Optics 05/2017; 22(9):091515., DOI:10.1117/1.JBO.22.9.091515', 'Rebeca Ferraz de Menezes, Catherine Malinda Harvey, Marleny Elizabeth Márquez de Martínez Gerbi, Zachary J Smith, Dan Smith, Juan C Ivaldi, Alton Phillips, James W Chan, Sebastian Wachsmann-Hogiu: Fs-laser ablation of teeth is temperature limited and provides information about the ablated components. Journal of Biophotonics 05/2017;, DOI:10.1002/jbio.201700042', 'Mehmet Kahraman, Emma R. Mullen, Aysun Korkmaz, Sebastian Wachsmann-Hogiu: Fundamentals and applications of SERS-based bioanalytical sensing. Nanophotonics 01/2017; 6(5)., DOI:10.1515/nanoph-2016-0174', 'Tzu-Yin Lin, Yuanpei Li, Qiangqiang Liu, Jui-Lin Chen, Hongyong Zhang, Diana Lac, Hua Zhang, Katherine W. Ferrara, Sebastian Wachsmann-Hogiu,Tianhong Li, Susan Airhart, Ralph deVere White, Kit S. Lam, Chong-Xian Pan, “Novel theranostic nanoporphyrins for photodynamic diagnosis and trimodal therapy for bladder cancer“, Biomaterials, 2016, 104, pp. 339-351.', 'Zachary Smith, Changwon Lee, Tatu Rojalin, Sebastian Wachsmann-Hogiu, Comment on “Label-Free Single Exosome Detection Using Frequency Locked Microtoroid Optical Resonators”, ACS Photonics, 2016, 3 (4), pp 716–717', 'Tatu Rojalin, Lauri Kurki, Timo Laaksonen, Tapani Viitala, Juha Kostamovaara, Keith C Gordon, Leonardo Galvis, Sebastian Wachsmann-Hogiu, Clare J Strachan, Marjo Yliperttula, Fluorescence-suppressed time-resolved Raman spectroscopy of pharmaceuticals using complementary metal-oxide semiconductor (CMOS) single-photon avalanche diode (SPAD) detector, Analytical and Bioanalytical Chemistry, 408 (3), 2016, 761-774.', 'Ruby K. Gill, Zachary J. Smith, Changwon Lee,  and Sebastian Wachsmann-Hogiu, “The effects of laser repetition rate on femtosecond laser ablation of dry bone: a thermal and LIBS study”, Journal of Biophotonics, 9 (1-2), 171-180, 2016. ', 'Zachary J Smith, Changwon Lee, Tatu Rojalin, Randy P Carney, Sidhartha Hazari, Alisha Knudson, Kit Lam, Heikki Saari, Elisa Lazaro Ibañez, Tapani Viitala, Timo Laaksonen, Marjo Yliperttula, Sebastian Wachsmann-Hogiu, Single exosome study reveals subpopulations distributed among cell lines with variability related to membrane content, Journal of Extracellular Vesicles, 5, 2015', 'Tingjuan Gao, Zachary Smith, Tzu-yin Lin, Danielle Carrade Holt, Stephen M Lane, Dennis L Matthews, Denis M Dwyre, James Hood, Sebastian Wachsmann-Hogiu, ”Smart and fast blood counting of trace volumes of body fluids from various mammalian species using a compact, custom-built microscope cytometer”, Analytical chemistry 87 (23), 11854-11862, 2015.', 'Ruby K Gill, Zachary J Smith, Ripul R Panchal, John W Bishop, Regina Gandour-Edwards, Sebastian Wachsmann-Hogiu, Preliminary fsLIBS study on bone tumors, Biomedical Optics Express, 6 (12), 4850-4858, 2015.', 'Kaiqin Chu, Zachary J. Smith, Sebastian Wachsmann-Hogiu, “Developing an inexpensive blood imaging system: where are we now?”, Expert Review of Medical Devices. 12(5), 613-627, 2015.', 'Changwon Lee, Christopher S. Robertson, An H. Nguyen, Mehmet Kahraman, Sebastian Wachsmann-Hogiu, “Thickness of a metallic film, in addition to its roughness, plays a significant role in SERS activity”, online, Scientific Reports 5, 2015', 'Sebastian Dochow, Dinglong Ma, Ines Latka, Thomas Bocklitz,Brad Hartl, Julien Bec, Hussain Fatakdawala, Eric Marple, Kirk Urmey, Sebastian Wachsmann-Hogiu, Michael Schmitt, Laura Marcu, Jürgen Popp, “Combined fiber probe for fluorescence lifetime and Raman spectroscopy”, Analytical and Bioanalytical Chemistry 06/2015; DOI:10.1007/s00216-015-8800-5.', 'Changwon Lee, Randy P. Carney, Sidhartha Hazari, Zachary Smith, Alisha Knudson, Christopher S. Robertson, Kit S. Lam and Sebastian Wachsmann-Hogiu, “3D plasmonic nanobowl platform for the study of exosomes in solution”, Nanoscale, 2015, DOI: 10.1039/C5NR01333J.', 'Ralph Green, Sebastian Wachsmann-Hogiu, “Development, history, and future of automated cell counters”, Clinics in Laboratory Medicine, 35, 2015, pp. 1-10. ', 'Mehmet Kahraman, Sebastian Wachsmann-Hogiu, “Label-Free and Direct Protein Detection on 3D Plasmonic Nanovoid Structures using Surface-Enhanced Raman Scattering”, Analytica Chimica Acta, 856, 2015, pp. 74-81.', 'Yuanpei Li, Tzu-yin Lin, Yan Luo, Qiangqiang Liu, Wenwu Xiao, Wenchang Guo, Diana Lac, Hongyong Zhang, Caihong Feng, Sebastian Wachsmann-Hogiu, Jeffrey H Walton, Simon R Cherry, Douglas J Rowland, David Kukis, Chongxian Pan, Kit S Lam, “A smart and versatile theranostic nanomedicine platform based on nanoporphyrin”, Nature Communications, 5, 2014.', 'R. K. Gill, F. Knorr, Z. J. Smith, M. Kahraman, D. Madsen, D. S. Larsen,  S. Wachsmann-Hogiu, “Characterization of Femtosecond Laser Induced Breakdown Spectroscopy (fsLIBS) and Applications for Biological Samples”, Applied Spectroscopy, Vol. 68, 9,  2014, pp. 949-54', 'Z. J. Smith, T. Gao, K. Chu, S. M. Lane, D. L. Matthews, D. M. Dwyre, J. Hood, K. Tatsukawa, L. Heifetz, and S. Wachsmann-Hogiu*, “Single-step preparation and image-based counting of minute volumes of human blood”, Lab on a Chip, 14 (16), 2014, pp. 3029-3036.', 'Z. Wang, M. Fan, D. Candas, T.-Q. Zhang, L. Qin, A. Eldridge, S. Wachsmann-Hogiu, K. M. Ahmed, B. A. Chromy, D. Nantajit, N. Duru, F. He, M. Chen, T. Finkel, L. S. Weinstein, and J. J. Li, “Cyclin B1/Cdk1 Coordinates Mitochondrial Respiration for Cell-Cycle G2/M Progression”, Developmental Cell, 29, April 28, 2014, pp. 217–232.', 'K. Chu, P. J. McMillan, Z. J. Smith, Jie Yin, J. Atkins, P. Goodwin, S. Wachsmann-Hogiu, and S. M. Lane, “Image reconstruction for structured-illumination microscopy with low signal level”, Optics Express, 22 (7), 2014, pp. 8687-8702.', 'M. A. S. de Oliveira, Z. J. Smith, F. Knorr, R. E. de Araujo, and S.Wachsmann-Hogiu, “Long Term Raman Spectral Study of Power-Dependent Photodamage in Red Blood Cells”, Applied Physics Letters, 104, 2014, 103702.', 'M. Kahraman, P. Daggumati, O. Kurtulus, E. Seker, S. Wachsmann-Hogiu, “Fabrication and Characterization of Flexible and Tunable Plasmonic Nanostructures”, Scientific Reports 3 : 3396 | DOI: 10.1038/srep03396 (Nature Journal).', 'T. Zhang, S. Osborn, C. Brandow, D. Dwyre, R. Green, S.M. Lane, S. Wachsmann-Hogiu,  “Structured Illumination-Based Super-Resolution Optical Microscopy for Hemato- and Cyto-Pathology Applications”, Analytical Cellular Pathology, 36 (1) 2013, pp. 27-35.', 'M. Kahraman ,  B.N. Balz and S. Wachsmann-Hogiu, “Hydrophobicity-driven self-assembly of protein and silver nanoparticles for protein detection using surface-enhanced Raman scattering”, Analyst, 138 (10), 2013, pp. 2906-2913.', 'Z. J. Smith, C.-W. Chang, L. S. Lawson, S. M. Lane, S. Wachsmann-Hogiu, “Precise Monitoring of Chemical Changes through Localization Analysis of Dynamic Spectra (LADS),” Applied Spectroscopy, 67(2), 2013, pp. 187-195.', 'Z. J. Smith*, K.Q Chu, S. Wachsmann-Hogiu, “Nanometer-Scale Sizing Accuracy of Particle Suspensions on an Unmodified Cell Phone Using Elastic Light Scattering”, PLoSONE, Oct. 2nd 2012, 7(10), e46030.', 'H. Zhang, J. Luo, Y. Li, P. T. Henderson, Y. Wang, S. Wachsmann-Hogiu, W. Zhao, K. S. Lam, C. X. Pan, “Characterization of high-affinity peptides and their feasability for use in nanotherapeutics targeting leukemia stem cells”, Nanomedicine-Nanotechnology Biology and Medicine, 2012, Vol 8, Issue 7, pp. 1116-1124. ', 'J. Y. Hwang, S. Wachsmann-Hogiu, V. K. Ramanujan, J. Ljubimova, Z. Gross, H. B. Gray, L. K. Medina-Kauwe, D. L. Farkas, “A multimode optical imaging system for preclinical applications in vivo: technology development , multiscale imaging, and chemotherapy assessment”, Mol. Imaging Biol., 2012, 14 (4), pp. 431-442. ', 'H. Agadjanian, D. Chu, JY Hwang, S. Wachsmann-Hogiu, A. Rentsendorj, L. Song, V. Valluripalli, J. Lubow, J. Ma, B. Sharifi, DL Farkas, LK Medina-Kauwe, “Chemotherapy targeting by DNA capture in viral protein particles”, Nanomedicine (London), October 2012, 7 (3), pp. 335-352. ', 'H. Agadjanian, D. Chu, JY Hwang, S. Wachsmann-Hogiu, A. Rentsendorj, L. Song, V. Valluripalli, J. Lubow, J. Ma, B. Sharifi, DL Farkas, LK Medina-Kauwe, “Chemotherapy targeting by DNA capture in viral protein particles”, Nanomedicine (London), Aug. 2012, 7 (8), pp. 1275-1276. (correction).', 'K.Q. Chu, Z.J. Smith, S. Wachsmann-Hogiu, S.M. Lane, “Super-resolved spatial light interference microscopy”, JOSA A, March 2012, 29 (3), pp. 344-351. ', 'Z. J. Smith, T. R. Huser, S. Wachsmann-Hogiu, “Raman scattering in pathology”, Analytical Cellular Pathology, 2012, 35 (3), pp. 145-163.', 'F. Knorr, D. R. Yankelevich, J. Liu, S. Wachsmann-Hogiu, L. Marcu, “Two-photon excited fluorescence lifetime measurements through a double-clad photonic crystal fiber for tissue microendoscopy”, J. of Biophotonics, Jan. 2012, 5 (1) pp. 14-19, doi: 10.1002/jbio.201100070.', 'Z. J. Smith, S. Strombom, S. Wachsmann-Hogiu, “Multivariate optical computing using a digital micromirror device for fluorescence and Raman spectroscopy”, Optics Express, 2011, Vol. 19, Issue 18, pp. 16950-16962.', 'Z. J. Smith, K. Chu, A. R. Espenson, M. Rahimzadeh, A. Gryshuk, M. Molinaro, D. M. Dwyre, S. M. Lane, D. Matthews, S. Wachsmann-Hogiu*, “Cell-phone-based platform for biomedical device development and education applications”, PLoSONE, 2011, 6(3): e17150.', 'Z. J. Smith, F. Knorr, C. V. Pagba, S. Wachsmann-Hogiu, “Rejection of fluorescence background in resonance and spontaneous Raman microspectroscopy”, Journal of Vizualized Experiments, 2011, http://www.jove.com/details.php?id=2592,  doi: 10.3791/2592. ', 'J. Y. Hwang, S. Wachsmann-Hogiu, V. Krishnan Ramanujan, A. G. Nowatzyk, Y. Koronyo, L. K. Medina Kauwe, Z. Gross, H. B. Gray, D. L. Farkas, “Multimodal wide-field two-photon excitation imaging: characterization of the technique for in vivo applications”, Biomedical Optics Express, Vol 2, Iss.2, 2011, pp. 356-364.', 'C. V. Pagba, S. M. Lane, S. Wachsmann-Hogiu, “Conformational changes in quadrulpex oligonucleotide structures probed by Raman spectroscopy”, Biomedical Optics Express, Vol. 2, Issue 2, 2011, pp. 207-217.', 'More Links:'],
        link: ['https://scholar.google.ca/citations?user=nMGrHzIAAAAJ&hl=en&oi=ao']
      }, { title: 'Conference Abstracts',
        data: ['Sebastian, W.-H. (2020). Raman spectroscopy for the analysis of exosomes (Conference Presentation). Proc.SPIE.', 'Meruyert, I., P. Ayyappa Sudalaiyadum, K. Sara and W.-H. Sebastian (2020). Direct on-sensor imaging for shadow-based microparticle characterization and bioluminescence imaging (Conference Presentation). Proc.SPIE.', 'Kheireddine, S., A. S. Perumal, D. V. Nicolau and S. Wachsmann-Hogiu (2019). High spatial resolution and large field of view mobile phone-based microscopy with adaptive phone screen illumination (Conference Presentation), SPIE.', 'Kahraman, M., A. Korkmaz, M. Kenton, G. Aksin, S. Wachsmann-Hogiu and J. Liu (2019). Biosilica-Ag nanocomposites on adhesive tapes for low-cost flexible SERS substrates (Conference Presentation), SPIE.', 'Liu, J., A. S. Perumal, F. R. Doucet, K. Rifai, L. Özcan, S. Kheireddine, D. V. Nicolau and S. Wachsmann-Hogiu (2019). A flexible and portable nanocomposite-based substrate for electrochemical biosensing (Conference Presentation), SPIE.']
      }]
    };
  },

  methods: {
    handleClick: function handleClick(tab, event) {
      console.log(tab, event);
    }
  }
});

/***/ }),

/***/ "1AA7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header1.c94b103.jpg";

/***/ }),

/***/ "1HJh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      data: [{
        avatar: __webpack_require__("GKqz"),
        name: 'Juanjuan Liu',
        position: 'Postdoc, BBME',
        something: 'Juanjuan joined the lab in September 2017. She is working on development of substrates to build biosensing systems used for low resources environments.',
        email: 'juanjuan.liu@mail.mcgill.ca',

        avatar1: __webpack_require__("VA9A"),
        name1: 'Sorina Suarasan',
        something1: '',
        position1: 'Postdoc, BBME',
        email1: ''

      }, {
        avatar: __webpack_require__("HpSS"),
        name: 'Meruyert Imanbekova',
        something: 'Meruyert joined the lab in January 2019. She is working on the identification and characterization of extracellular vesicles associated biomarkers of neurodegenerative diseases.',
        position: 'Ph.D. Candidate, BBME',
        email: 'meruyert.imanbekova@mail.mcgill.ca',

        avatar1: __webpack_require__("9tXu"),
        name1: 'Lena Kozarov',
        something1: '',
        position1: 'Undergraduate student, BE',
        email1: ''
      }, {
        avatar: __webpack_require__("8fJ7"),
        name: 'Reza Abbasi',
        something: 'Reza joined the lab in September 2019. He is working on integrated optical systems for the characterization of sub-micrometer vesicles.',
        position: 'Ph.D. Candidate, BBME',
        email: 'reza.abbasi@mail.mcgill.ca',

        avatar1: __webpack_require__("ghwY"),
        name1: 'Sara Kheireddine',
        position1: 'Ph.D., BBME',
        something1: '',
        email1: ''
      }, {
        avatar: __webpack_require__("I8pt"),
        name: 'Adam Melnyk',
        something: 'Adam joined the lab in September 2020. He is working on integrated optical systems for biosensing.',
        position: 'Master\'\s Student, BBME',
        email: 'adam.melnyk@mail.mcgill.ca',

        avatar1: __webpack_require__("9tXu"),
        name1: 'Maya Kenton',
        something1: '',
        position1: 'Undergraduate student, BE',
        email1: ''
      }, {
        avatar: __webpack_require__("ZJ2D"),
        name: 'Mohul Sharma',
        something: '',
        position: 'Undergraduate Student, BE',
        email: 'mohul.sharma@mail.mcgill.ca',

        avatar1: __webpack_require__("lwv8"),
        name1: 'Houda Shafique',
        something1: '',
        position1: 'Undergraduate student, BE',
        email1: ''
      }, {
        avatar: __webpack_require__("6Sac"),
        name: 'Marion Vandewynckele-Bossut',
        something: '',
        position: 'Undergraduate Student, BE',
        email: 'marion.vandewynckele-bossut@mail.mcgill.ca',

        avatar1: __webpack_require__("9tXu"),
        name1: 'Reem kettaneh',
        position1: 'Master\'\s Student',
        email1: ''
      }, {
        avatar1: __webpack_require__("9tXu"),
        name1: 'Mehmet Kahraman',
        position1: '',
        something1: '',
        email1: ''
      }, {
        avatar1: __webpack_require__("9tXu"),
        name1: 'Aysun Korkmaz',
        position1: 'Ph.D.',
        something1: '',
        email1: ''
      }]

    };
  },

  methods: {}

});

/***/ }),

/***/ "3GDT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3y59":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5ZbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__ = __webpack_require__("kXiA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a49fa3a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__("KrRW");
function injectStyle (ssrContext) {
  __webpack_require__("AJr4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a49fa3a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5cLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__ = __webpack_require__("Vj7G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_d1e9e4ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__("r/ZB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_d1e9e4ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "69JZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tabs',{on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"HOME","name":"1"}},[_c('Home')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"RESEARCH","name":"2"}},[_c('Research')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"PUBLICATIONS","name":"3"}},[_c('Publication')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"TEAM","name":"4"}},[_c('Team')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"TEACHING","name":"5"}},[_c('Teaching')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"RESOURCES","name":"6"}},[_c('Resources')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"CONTACT","name":"7"}},[_c('Contact')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6FDI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sebastian.4dc895a.jpg";

/***/ }),

/***/ "6Sac":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Marion.00b76e7.jpg";

/***/ }),

/***/ "7qBg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_packages_col_src_col__ = __webpack_require__("kMct");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ElCol: __WEBPACK_IMPORTED_MODULE_0_element_ui_packages_col_src_col__["a" /* default */] },
  data: function data() {
    return {
      center: { lat: 10.0, lng: 10.0 }
    };
  },

  methods: {
    handleClick: function handleClick(tab, event) {
      console.log(tab, event);
    }
  }
});

/***/ }),

/***/ "8fJ7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Reza.d807c39.jpg";

/***/ }),

/***/ "8mDM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Research_vue__ = __webpack_require__("JeLB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31ff52ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Research_vue__ = __webpack_require__("wDCD");
function injectStyle (ssrContext) {
  __webpack_require__("nOuz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31ff52ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Research_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31ff52ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Research_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "921z":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header2.0009cf1.jpg";

/***/ }),

/***/ "9UFW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home1.e4be9ca.png";

/***/ }),

/***/ "9tXu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/team.23ce024.jpg";

/***/ }),

/***/ "AJr4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ARFN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Amhf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderContent_vue__ = __webpack_require__("p+Ud");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c263e20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderContent_vue__ = __webpack_require__("+FtO");
function injectStyle (ssrContext) {
  __webpack_require__("kC+2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c263e20"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c263e20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BNT0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-collapse',{on:{"change":_vm.handleChange},model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},_vm._l((_vm.news),function(item){return _c('el-collapse-item',{key:"item",attrs:{"title":item.title,"name":item.title}},_vm._l((item.data),function(line){return _c('div',{key:line},[_c('div',{staticStyle:{"min-height":"23px"}},[_vm._v(_vm._s(line))])])}))}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CGe1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FIJ3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GBCC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left"}},[_c('div',[_c('h3',[_vm._v("Supervisor")]),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('img',{staticStyle:{"width":"90%","height":"auto","margin-top":"12px"},attrs:{"src":__webpack_require__("6FDI")}})]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('p',[_c('strong',[_vm._v("Sebastian Wachsmann-Hogiu")])]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p',[_vm._v("Professor")]),_vm._v(" "),_c('p',[_vm._v("BE and BBME")]),_vm._v(" "),_c('a',{attrs:{"href":"sebastian.wachsmannhogiu@mcgill.ca"}},[_vm._v("sebastian.wachsmannhogiu@mcgill.ca")])])],1)],1),_vm._v(" "),_c('div',[_c('h3',[_vm._v("Current Members:")]),_vm._v(" "),_c('el-row',_vm._l((_vm.data),function(item){return _c('el-col',{attrs:{"span":24}},[_c('el-row',[_c('el-col',{staticStyle:{"padding":"6px"},attrs:{"span":8}},[_c('img',{staticStyle:{"width":"80%","height":"auto"},attrs:{"src":item.avatar}})]),_vm._v(" "),_c('el-col',{staticStyle:{"text-align":"justify"},attrs:{"span":10}},[_c('p',[_c('strong',[_vm._v(_vm._s(item.name))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.position))]),_vm._v(" "),_c('a',{attrs:{"href":'mailto:' + item.email}},[_vm._v(_vm._s(item.email))]),_vm._v(" "),_c('p',[_vm._v("\n             "+_vm._s(item.something)+"\n            ")])])],1)],1)}))],1),_vm._v(" "),_c('div',[_c('h3',[_vm._v("Past Members:")]),_vm._v(" "),_c('el-row',_vm._l((_vm.data),function(item){return _c('el-col',{attrs:{"span":6}},[_c('el-row',[_c('el-col',{staticStyle:{"padding":"6px"},attrs:{"span":14}},[_c('img',{staticStyle:{"width":"100%","height":"auto"},attrs:{"src":item.avatar1}})]),_vm._v(" "),_c('el-col',{attrs:{"span":18}},[_c('p',[_c('strong',[_vm._v(_vm._s(item.name1))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.position1))]),_vm._v(" "),_c('a',{attrs:{"href":'mailto:' + item.email1}},[_vm._v(_vm._s(item.email1))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.something1))])])],1)],1)}))],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GKqz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/juan.7ae0a20.jpg";

/***/ }),

/***/ "GVlP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HpSS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Mira.50e2408.jpg";

/***/ }),

/***/ "I8pt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Adam.2af9eb0.jpeg";

/***/ }),

/***/ "JeLB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      data: [{
        title: 'Novel nanobiomaterials for global health and global development applications',
        desc: ['GOAL: Develop novel inexpensive nanobiomaterials with improved mechanical, optical, and electrical properties suitable for a wide range of applications ', '•  Nanomanufacturing of nanocomposite materials', '•  Characterization of these materials ', '•  Applications in biosensing, antimicrobial, water purification, and clean energy'],
        pic: 'http://image.ibb.co/bHZjtR/project3.png'

      }, {
        title: 'Biosensing with Raman and Plasmonics(Surface Enhanced Raman Spectroscopy)',
        desc: ['GOAL: Develop novel biosensing capabilities for the detection and characterization of molecules and sub-micrometer organelles (such as exosomes)', '•  Nanomanufacturing and characterization of plasmonic substrates', '•  Functionalization of substrates with aptamers or antibodies for specific detection of molecules of interest', '•  Analytical measurements and chemical characterization'],
        pic: 'http://preview.ibb.co/c54WOR/projejct2_2.jpg'
      }, {
        title: 'Integration and miniaturization of optical technologies for inexpensive and portable diagnosis',
        desc: ['GOAL: Develop photonic technologies for diagnosis in remote locations', '                                                                 ', '•  Microscopy, spectroscopy and light scattering on a cell phone', '•  Rapid, automated blood count on a portable platform using very small amounts of blood'],
        pic: 'http://preview.ibb.co/dY8rOR/project1_3.png'

      }]
    };
  },

  methods: {}
});

/***/ }),

/***/ "KY2+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__("7qBg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c58b3a90_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__("otD5");
function injectStyle (ssrContext) {
  __webpack_require__("ARFN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c58b3a90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c58b3a90_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KrRW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69a41314_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("XRSH");
function injectStyle (ssrContext) {
  __webpack_require__("vaz/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69a41314_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_fullcalendar__ = __webpack_require__("xzgZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_fullcalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_fullcalendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__ = __webpack_require__("sA6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__("M93x");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__, {
  load: {
    key: 'AIzaSyBvWE_sIwKbWkiuJQOf8gSk9qzpO96fhfY',
    libraries: 'places' // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('full-calendar', __WEBPACK_IMPORTED_MODULE_2_vue_fullcalendar___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */] }
});

/***/ }),

/***/ "NwSN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left"}},[_c('h4',{staticStyle:{"padding":"0 20px 0 20px"}},[_vm._v("\n   To be updated.\n  ")]),_vm._v(" "),_c('full-calendar',{attrs:{"events":_vm.fcEvents,"locale":"en"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OuGl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left"}},_vm._l((_vm.data),function(item){return _c('el-card',{key:"item.title",staticClass:"box-card",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v(_vm._s(item.title))])]),_vm._v(" "),_vm._l((item.data),function(t){return _c('div',{staticClass:"text item",staticStyle:{"margin-top":"6px"}},[_c('span',[_vm._v(_vm._s(t))])])}),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"15px"}}),_vm._v(" "),_vm._l((item.link),function(link){return _c('div',{staticStyle:{"margin-top":"12px"}},[_c('a',{attrs:{"href":link}},[_vm._v(_vm._s(link))])])})],2)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R7HE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__ = __webpack_require__("XK7J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a159bd66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__ = __webpack_require__("BNT0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a159bd66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TxWn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__content_Home__ = __webpack_require__("igjh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_Research__ = __webpack_require__("8mDM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__content_Publication__ = __webpack_require__("e7Rc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__content_Team__ = __webpack_require__("b6P6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__content_Teaching__ = __webpack_require__("z9B2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__content_Resources__ = __webpack_require__("eKoo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__content_Contact__ = __webpack_require__("KY2+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      activeName: '1'
    };
  },

  methods: {
    handleClick: function handleClick(tab, event) {
      this.activeName = tab.name;
    }
  },
  components: {
    Home: __WEBPACK_IMPORTED_MODULE_0__content_Home__["a" /* default */],
    Research: __WEBPACK_IMPORTED_MODULE_1__content_Research__["a" /* default */],
    Publication: __WEBPACK_IMPORTED_MODULE_2__content_Publication__["a" /* default */],
    Team: __WEBPACK_IMPORTED_MODULE_3__content_Team__["a" /* default */],
    Teaching: __WEBPACK_IMPORTED_MODULE_4__content_Teaching__["a" /* default */],
    Resources: __WEBPACK_IMPORTED_MODULE_5__content_Resources__["a" /* default */],
    Contact: __WEBPACK_IMPORTED_MODULE_6__content_Contact__["a" /* default */]
  }
});

/***/ }),

/***/ "V+HF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

var demoEvents = [{
  title: 'to do list',
  start: '2017-11-9',
  end: '2017-11-20'
}, {
  title: 'Out of Office',
  start: '2017-5-18',
  end: '2017-5-18'
}];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      fcEvents: demoEvents
    };
  },

  methods: {}
});

/***/ }),

/***/ "VA9A":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sorina.f67d564.jpg";

/***/ }),

/***/ "XK7J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      activeNames: ['1'],
      news: [{
        title: 'News',
        data: ['July 22, 2022: Adam submits final Masters thesis', '', 'May 22, 2022: Mira passes here per-submission meeting', '', 'April 13, 2022: The manuscript on "Recent advances in optical label-free characterization of extracellular vesicles" is published in the journal Nanophotonics', '', 'Feburary, 2022: Sebastian and Juanjuan receive TechAccelR grant  for the project “On-Chip Chemiluminescence Biosensor for Food Safety” ', '', 'Feburary, 2022: Sebastian and Juanjuan receive NSERC Idea to Innovation (I2I) grant  for the project “Market Assessment: Market analysis for monitoring gout disease at the point of need using a CMOS-based device” ', '', 'Feburary 9, 2022: The manuscript on "SE-ECL on CMOS: a miniaturized electrochemiluminescence biosensor" is published in the journal Lab on a Chip', '', 'August, 2021: Sebastian is awarded Louis-Ho Faculty Scholar in Technological Innovation', '', 'August 19, 2021: Juanjuan passed her Ph.D. oral defence ', '', 'July 14, 2021: The manuscript on "Multimodal electrochemical and SERS platform for chlorfenapyr detection" is published in the journal Applied Surface Science', '', 'June 7, 2021: The manuscript on "Identification of amyloid beta in small extracellular vesicles via Raman spectroscopy" is published in the journal Nanoscale Advances', '', 'April 12, 2021: Sara passed her Ph.D. oral defence ', '', 'September 2, 2020: The manuscript on "Superhydrophobic bowl-like SERS substrates patterned from CMOS sensors for extracellular vesicle characterization" is published in the Journal of Materials Chemistry B', '', 'September 1, 2020: Adam joins the lab as a master\'\s student', '', 'September 1, 2020: The manuscript on "Lensless, reflection-based dark-field microscopy (RDFM) on a CMOS chip" is published in the journal Biomedical Optics Express', '', 'August 31, 2020: Reza passes his pre-comprehensive meeting', '', 'June 12, 2020: The manuscript on "An AgNP-deposited commercial electrochemistry test strip as a platform for urea detection" is published in the journal Scientific Reports', '', 'May 19, 2020: Mira passes her comprehensive meeting', '', 'February 6, 2020: Sebastian gives an invited talk on "Raman spectroscopy for the analysis of exosomes" at SPIE Photonics West Conference', '', 'February 3, 2020: An oral presentations about "Direct on-sensor imaging for shadow-based microparticle characterization and bioluminescence imaging" is given at SPIE Photonics West Conference', '', 'February 2, 2020: An oral presentations about "AgNP-decorated 3D nano-bowl structures for SERS detection of urea and exosomes" is given at SPIE Photonics West Conference', '', 'January 13, 2020: Juanjuan passes her progress meeting', '', 'December 13, 2019: An editorial on "Plasmonic Technologies for Bioanalytical Applications" is published in the journal Frontiers in Chemistry', '', 'December 12, 2019: The manuscript on "Are plasmonic optical biosensors ready for use in point-of-need applications?" is published in the journal Analyst', '', 'December 10, 2019: Sara passes her pre-submission meeting', '', 'November, 2019: Sebastian receives 3-year DND funding as part of the DND-IDEAS Network together with other insitutions in Canada, USA, and Europe', '', 'November 26, 2019: Reza passes his preliminary meeting', '', 'October 30, 2019: Meruyert passes her pre-comprehensive meeting', '', 'September 1, 2019: Reza joins the lab as a PhD student', '', 'August 2, 2019: The manuscript on phase contrast imaging with dual-phone illumination-imaging system is published in the journal Biomedical Optics Express and it is chosen as the Editor\'s pick', '', 'July 21, 2019: Juanjuan and Meruyert went to Center for Biophotonics, UC Davis in Sacramento for a short research exchange. This trip was funded by Graduate Mobility Award (GMA)', '', 'July 1, 2019: Sorina joins the lab as a postdoctoral fellow', '', 'April 23, 2019: Meruyert passes her preliminary qualifying meeting exam', '', 'February 18, 2019, Reem joins the lab as a visiting MSc student', '', 'February 4, 2019: Sara gives an oral presentation at SPIE Photonics West Conference', '', 'February 3, 2019: Juanjuan gives an oral presentation at SPIE Photonics West Conference', '', 'February 3, 2019: Sebastian gives an oral presentation at SPIE Photonics West Conference', '', 'January 30, 2019: the manuscript on dual-phone illumination-imaging system is published in the journal Lab on a Chip', '', 'January 7, 2019, Meruyert joins the lab as a PhD student. She is the recipient of a highly prestigious Bolashak scholarship', '', 'November 21, 2018: Juanjuan passes her PhD comprehensive exam', '', 'August 18, 2018: the manuscript on bionanocomposite materials for biosensing is now published in the journal ACS Applied Nano Materials', '', 'August 12, 2018: second manuscript in a year on Alzheimer’s disease is now published in collaboration with colleagues at UC Davis: https://twitter.com/Molecules_MDPI/status/1028845646634078208', '', 'July 3, 2018: manuscript on light scattering was accepted for publication. More to follow.', '', 'June 11, 2018: Sebastian gives invited presentation at ICASS 2018 in Toronto', '', 'June 7, 2018: Sara has an oral presentation at SPIE Photonics North conference', '', 'June 6, 2018: Juanjuan gives a poster presentation at SPIE Photonics North conference', '', 'May 16, 2018: Juanjuan passes the PhD comprehensive preparation exam', '', 'April 2018: Sebastian is awarded a 5 year NSERC Discovery grant', '', 'March 5, 2018: Sebastian presents at the Pathology Grand Rounds at UC Davis on “Novel Photonic technologies for diagnosis"', '', 'March 2018: Sebastian is awarded a CAD 0.5M equipment grant', '', 'December 7, 2017: Sara passes her PhD comprehensive exam', '', 'December 5, 2017: Sebastian gives invited presentation at the University of Basel Switzerland', '', 'November 16, 2017: Juanjuan passes her preliminary qualifying meeting exam', '', 'November 10, 2017: Sebastian gives invited presentation at Iowa State University, Ames, as part of the SAS tour speaker', '', 'November 8, 2017: Sebastian gives invited presentation at Maryville University, St. Louis, as part of the SAS tour speaker', '', 'September 16, 2017: Sebastian gives invited presentation at Purdue symposium as part of the SAS tour speaker']
      }, {
        title: 'Feedback',
        data: ['To be updated.', '']
      }]
    };
  },

  methods: {
    handleChange: function handleChange() {}
  }
});

/***/ }),

/***/ "XRSH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"p"}},[_c('div',{staticStyle:{"flex":"1"}}),_vm._v(" "),_c('div',{attrs:{"id":"app"}},[_c('el-container',[_c('el-header',{attrs:{"height":"150px"}},[_c('HeaderContent')],1),_vm._v(" "),_c('el-main',[_c('TabContent')],1),_vm._v(" "),_c('el-footer',[_vm._v("\n        Sebastian's Lab\n      ")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YI6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__("jIen");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4c86d54a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__("3y59");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4c86d54a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ZJ2D":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Mohul.0965dbe.jpg";

/***/ }),

/***/ "b6P6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Team_vue__ = __webpack_require__("1HJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bf2776a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Team_vue__ = __webpack_require__("GBCC");
function injectStyle (ssrContext) {
  __webpack_require__("CGe1")
  __webpack_require__("eCvD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7bf2776a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Team_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bf2776a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Team_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bk6M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "doCN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e7Rc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Publication_vue__ = __webpack_require__("0YQ7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f45bc80e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Publication_vue__ = __webpack_require__("OuGl");
function injectStyle (ssrContext) {
  __webpack_require__("GVlP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f45bc80e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Publication_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f45bc80e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Publication_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eCvD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eKoo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Resources_vue__ = __webpack_require__("V+HF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b62c4e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Resources_vue__ = __webpack_require__("NwSN");
function injectStyle (ssrContext) {
  __webpack_require__("p7Yt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b62c4e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Resources_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b62c4e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Resources_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ghwY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Sara.9559a0a.jpg";

/***/ }),

/***/ "iXIU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header6.403f162.jpg";

/***/ }),

/***/ "iZrZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left"}},[_c('div',[_c('h3',[_vm._v("Courses:")]),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('p',[_vm._v("BIEN 210: Electrical and Optical Properties of Biological Systems")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p',[_vm._v("BIEN 390: Bioengineering Laboratory")]),_vm._v(" "),_c('p',[_vm._v("BIEN 560: Biosensors")])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "igjh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("uTwC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b9ee7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("yoma");
function injectStyle (ssrContext) {
  __webpack_require__("iuEy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60b9ee7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b9ee7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iuEy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k4rc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabContent_vue__ = __webpack_require__("TxWn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b4d9b78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabContent_vue__ = __webpack_require__("69JZ");
function injectStyle (ssrContext) {
  __webpack_require__("bk6M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b4d9b78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kC+2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lL03":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header3.21260c8.jpg";

/***/ }),

/***/ "lwv8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Houda.a779ed8.png";

/***/ }),

/***/ "nOuz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oKsf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header4.a8087ec.jpg";

/***/ }),

/***/ "otD5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left"}},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('h3',[_vm._v("\n        Prof. Sebastian Wachsmann-Hogiu \n      ")]),_vm._v(" "),_c('h4',[_vm._v("\n      Department of Bioengineering \n      ")]),_vm._v(" "),_c('h4',[_vm._v("\n      McConnell Engineering Building, Room 362 \n      ")]),_vm._v(" "),_c('h5',[_vm._v("\n       3480 Rue University, Montréal, QC H3A 0E9\n      ")]),_vm._v(" "),_c('h5',[_vm._v("\n      Université du Québec à Montréal Complexe des Sciences Pierre-Dansereau,Room 5585 \n      ")]),_vm._v(" "),_c('h4',[_vm._v("\n      Phone: 438-350 2897\n      ")]),_vm._v(" "),_c('h4',[_vm._v("\n      Email: sebastian.wachsmannhogiu@mcgill.ca\n      ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('gmap-map',{staticStyle:{"width":"500px","height":"300px"},attrs:{"center":{lat:45.506078, lng:-73.576228},"zoom":16,"map-type-id":"terrain"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p+Ud":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      activeName: '1'

    };
  },

  methods: {
    handleClick: function handleClick(tab, event) {
      console.log(tab, event);
    }
  }
});

/***/ }),

/***/ "p7Yt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "preG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__ = __webpack_require__("osty");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7d2989da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__("doCN");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7d2989da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "r/ZB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r2t2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header5.08f0a3e.jpg";

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uTwC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_News__ = __webpack_require__("R7HE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  methods: {},
  components: {
    News: __WEBPACK_IMPORTED_MODULE_0__home_News__["a" /* default */]
  }
});

/***/ }),

/***/ "vaz/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wDCD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left"}},_vm._l((_vm.data),function(item){return _c('el-card',{key:item.title,staticClass:"box-card",staticStyle:{"margin-top":"12px"}},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('h3',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_vm._l((item.desc),function(desc){return _c('div',[_vm._v("\n          "+_vm._s(desc)+"\n        ")])})],2),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('img',{staticClass:"image",attrs:{"src":item.pic}})])],1)],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabContent__ = __webpack_require__("k4rc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderContent__ = __webpack_require__("Amhf");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    TabContent: __WEBPACK_IMPORTED_MODULE_0__components_TabContent__["a" /* default */],
    HeaderContent: __WEBPACK_IMPORTED_MODULE_1__components_HeaderContent__["a" /* default */]
  }
});

/***/ }),

/***/ "yoma":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left"}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":16}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('h2',[_vm._v("Welcome to Sebastian's Lab!")]),_vm._v("\n        The mission of our lab is to develop and apply technologies for global health and global development problems."),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n        The vision of our lab is to address problems of global relevance by challenging paradigmes and shattering disciplinary barriers.\n        "),_c('div',[_c('img',{staticStyle:{"width":"100%","height":"auto","margin-top":"12px"},attrs:{"src":__webpack_require__("9UFW")}})])])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('h2',[_vm._v("News")]),_vm._v(" "),_c('News')],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "z9B2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_736243d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Teaching_vue__ = __webpack_require__("iZrZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_736243d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Teaching_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.0c55811f2d3fa127e08e.js